<template>
    <ol class="breadcrumb d-sm-down-none bg-white">
        
            <li
                v-if="breadcrumbs.breadcrumbs.length"
                v-for="(crumb, index) in breadcrumbs.breadcrumbs"
                class="breadcrumb-item">
                    <router-link v-if="index != breadcrumbs.breadcrumbs.length - 1" :to="{ name: crumb.to.name }">{{ crumb.text }}</router-link>
                    <span v-else>{{ crumb.text }}</span>
            </li>


    </ol>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: mapState(['breadcrumbs'])
    }
</script>